/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Trial_Days_ColInputs */

const en_admin_invite_codes_trial_days_col = /** @type {(inputs: Admin_Invite_Codes_Trial_Days_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trial`)
};

/**
* | output |
* | --- |
* | "Trial" |
*
* @param {Admin_Invite_Codes_Trial_Days_ColInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_trial_days_col = /** @type {((inputs?: Admin_Invite_Codes_Trial_Days_ColInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Trial_Days_ColInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_trial_days_col(inputs)
});
export { admin_invite_codes_trial_days_col as "admin.invite_codes.trial_days_col" }